module.exports = __webpack_public_path__ + "static/media/lbnl-logo.07b53fa3.png";